export default __webpack_public_path__ + "d29623d.png";